import * as React from 'react';
import * as d3 from 'd3';
import './svgStyles.css';
import { toast, ToastContainer } from 'react-toastify';
import { IoMdClose } from "react-icons/io";
import Modal from "react-awesome-modal";


class SvgDisplay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            waypoints : [],
            // replace with props with respective student values
            totalLessons : this.props.totalLessons,
            lessonsCompleted : this.props.completedLessons,
            lessonAllocations: this.props.currentLessons,
            openModal: false,
            clickedIdx: 0, // set default to first lesson in the course
            nextLesson: 0
        }
        this.calculateWaypointCoords = this.calculateWaypointCoords.bind(this);
        // this.drawCircles = this.drawCircles.bind(this);
        this.determineFill = this.determineFill.bind(this);
        this.determineStroke = this.determineStroke.bind(this);
        // this.handlePointClick = this.handlePointClick.bind(this);
        // this.lessonModal = this.lessonModal.bind(this);
        // this.closeModal = this.closeModal.bind(this);
    }

    
    componentDidMount() {
        this.calculateWaypointCoords();
    }


    // handlePointClick(point) {
    //     this.setState({ openModal: true, clickedIdx: point, nextLesson: this.state.lessonsCompleted})
    // }
    // closeModal() {
    //     this.setState({ openModal: false })
    // }


    calculateWaypointCoords() {
        let animatedPath = this.refs.animPath;
        let points = [];
        let pathLength = animatedPath.getTotalLength();
        // alert(pathLength + "\n" + animatedPath.getPointAtLength(2000).x);
        for(let i = 1; i <= this.state.totalLessons; i++){
            let pointsObj = {};
            pointsObj.name = "lesson"+i;
            pointsObj.y = Math.round(animatedPath.getPointAtLength((i/this.state.totalLessons) * (pathLength - 12)).y);
            pointsObj.x = Math.round(animatedPath.getPointAtLength((i/this.state.totalLessons) * (pathLength - 12 )).x);
            points.push(pointsObj);
        }
        // alert("waypoints" + points.length);
        // this.setState({waypoints: points});

        const f1Svg = d3.select('#f1Track');
        for (let i = 0; i < points.length; i++) {
            f1Svg.append("circle")
                .attr("cx", points[i].x)
                .attr("cy", points[i].y)
                .attr("r", 10)
                .style("fill", this.determineFill(i))
                .style("stroke", this.determineStroke(i))
                .style("cursor", "pointer")
                // .on("click", this.handlePointClick.bind(this, i));
            //also append the numbers
            // the +- 5 difference accounts for half the radius
            // in order to center the text in the circle
            f1Svg.append("text")
                .attr("x", points[i].x)
                .attr("y", points[i].y + 3)
                .text(i + 1)
                .style("fill", this.determineStroke(i))
                .style("text-align", "center")
                .style("font-size", "0.6rem")
                .style("font-family", "Roboto")
                .style("font-weight", "bold")
                .style("text-anchor", "middle")
                .style("cursor", "pointer")
                // .on("click", this.handlePointClick.bind(this, i));
        }

        //animate the path with d3, stroke-dasharray and stroke-dashoffset
        var animate = d3.transition()
                    .duration(8000)

        let path = d3.select("#animated-track");
        // let lengthOfPath = path.getTotalLength();
        path.attr("stroke-dasharray", pathLength)
            .attr("stroke-dashoffset", pathLength)
            .transition(animate)
            .attr("stroke-dashoffset", pathLength * (1 - (this.state.lessonsCompleted/this.state.totalLessons)));

    }

    determineFill(i) {
        return i < this.state.lessonsCompleted ? "#ff0033" : "#000";
    }

    determineStroke(i) {
        return i < this.state.lessonsCompleted ? "#000" : "grey";
    }

    // lessonModal() {
    //     const { lessonAllocations, clickedIdx, nextLesson, lessonsCompleted } = this.state;
    //     let clickedLesson = lessonAllocations[clickedIdx];
    //     // console.log(`idx ${clickedIdx} lessoncompleted ${clickedLesson.Completed} completedLength: ${completedLessons}`);

    //     if(lessonAllocations.length > 0){
    //         return(
    //         <Modal
    //             visible={this.state.openModal}
    //             effect="fadeInDown"
    //             onClickAway={this.closeModal}
    //             width="400"
    //             height="200"
    //             >
    //             <div className="f1-modal-container">
    //             <div className="f1-modal-header">
    //                 <h2 className="f1-lesson-title">{clickedLesson.Title}</h2>
    //                 <IoMdClose
    //                     size="20px"
    //                     onClick={this.closeModal}
    //                     className="f1-modal-close"
    //                 />                    
    //             </div>
    //             <div className="f1-modal-body">
    //                     <p className= "f1-lesson-description">{clickedLesson.Description}</p>
    //                     <button style={clickedIdx === nextLesson ? {display: "block"} : {display: "none"}} 
    //                         className="blue-button f1-start-lesson"
    //                         onClick = {() => this.props.onStartLesson(clickedIdx, clickedLesson.Completed, lessonsCompleted)}
    //                         >Start Lesson</button>
    //                 </div>
    //             </div>
    //         </Modal>
    //     )
    //     }else{
    //         return;
    //     }

    // }

    render(){
        return (
            <div>
                {/* {this.lessonModal()} */}
                <svg id="f1Track" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1070 285">
                    <path id="main-track" d="M32 26.2h113c6.1 0 11 7.9 11 17.7v48.3c0 9.8-4.9 17.7-11 17.7h-23c-6.1 0-11 7.9-11 17.7v24.2c0 9.8 4.9 17.7 11 17.7h71c6.1 0 11-7.9 11-17.7V79.4c0-9.8 4.9-17.7 11-17.7h44c6.1 0 11 7.9 11 17.7v133.7c0 9.8-4.9 17.7-11 17.7h-45c-6.1 0-11 7.9-11 17.7s4.9 17.7 11 17.7h93c6.1 0 11-7.9 11-17.7V60c0-9.8 4.9-17.7 11-17.7h116c6.1 0 11 7.9 11 17.7v32.2c0 9.8-4.9 17.7-11 17.7h-55c-6.1 0-11 7.9-11 17.7v17.7c0 9.8 4.9 17.7 11 17.7h54c6.1 0 11 7.9 11 17.7v24.2c0 9.8 4.9 17.7 11 17.7h81c6.1 0 11-7.9 11-17.7v-82.1c0-9.8 4.9-17.7 11-17.7h39c6.1 0 11 7.9 11 17.7V213c0 9.8 4.9 17.7 11 17.7h25c6.1 0 11-7.9 11-17.7V45.5c0-9.8 4.9-17.7 11-17.7h34c6.1 0 11 7.9 11 17.7v194.9c0 9.8 4.9 17.7 11 17.7h158c6.1 0 11-7.9 11-17.7v-43.5c0-9.8-4.9-17.7-11-17.7h-90c-6.1 0-11-7.9-11-17.7V71.3c0-9.8 4.9-17.7 11-17.7h128c6.1 0 11 7.9 11 17.7v125.6c0 9.8 4.9 17.7 11 17.7h88" fill="none" stroke="#111" stroke-width="16" stroke-linecap="round" stroke-linejoin="round"/>
                    <path ref="animPath" id="animated-track" class="animated-track" d="M32 26.2h113c6.1 0 11 7.9 11 17.7v48.3c0 9.8-4.9 17.7-11 17.7h-23c-6.1 0-11 7.9-11 17.7v24.2c0 9.8 4.9 17.7 11 17.7h71c6.1 0 11-7.9 11-17.7V79.4c0-9.8 4.9-17.7 11-17.7h44c6.1 0 11 7.9 11 17.7v133.7c0 9.8-4.9 17.7-11 17.7h-45c-6.1 0-11 7.9-11 17.7s4.9 17.7 11 17.7h93c6.1 0 11-7.9 11-17.7V60c0-9.8 4.9-17.7 11-17.7h116c6.1 0 11 7.9 11 17.7v32.2c0 9.8-4.9 17.7-11 17.7h-55c-6.1 0-11 7.9-11 17.7v17.7c0 9.8 4.9 17.7 11 17.7h54c6.1 0 11 7.9 11 17.7v24.2c0 9.8 4.9 17.7 11 17.7h81c6.1 0 11-7.9 11-17.7v-82.1c0-9.8 4.9-17.7 11-17.7h39c6.1 0 11 7.9 11 17.7V213c0 9.8 4.9 17.7 11 17.7h25c6.1 0 11-7.9 11-17.7V45.5c0-9.8 4.9-17.7 11-17.7h34c6.1 0 11 7.9 11 17.7v194.9c0 9.8 4.9 17.7 11 17.7h158c6.1 0 11-7.9 11-17.7v-43.5c0-9.8-4.9-17.7-11-17.7h-90c-6.1 0-11-7.9-11-17.7V71.3c0-9.8 4.9-17.7 11-17.7h128c6.1 0 11 7.9 11 17.7v125.6c0 9.8 4.9 17.7 11 17.7h88" fill="none" stroke="#f03" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path id="dotted-track" d="M32 26.2h113c6.1 0 11 7.9 11 17.7v48.3c0 9.8-4.9 17.7-11 17.7h-23c-6.1 0-11 7.9-11 17.7v24.2c0 9.8 4.9 17.7 11 17.7h71c6.1 0 11-7.9 11-17.7V79.4c0-9.8 4.9-17.7 11-17.7h44c6.1 0 11 7.9 11 17.7v133.7c0 9.8-4.9 17.7-11 17.7h-45c-6.1 0-11 7.9-11 17.7s4.9 17.7 11 17.7h93c6.1 0 11-7.9 11-17.7V60c0-9.8 4.9-17.7 11-17.7h116c6.1 0 11 7.9 11 17.7v32.2c0 9.8-4.9 17.7-11 17.7h-55c-6.1 0-11 7.9-11 17.7v17.7c0 9.8 4.9 17.7 11 17.7h54c6.1 0 11 7.9 11 17.7v24.2c0 9.8 4.9 17.7 11 17.7h81c6.1 0 11-7.9 11-17.7v-82.1c0-9.8 4.9-17.7 11-17.7h39c6.1 0 11 7.9 11 17.7V213c0 9.8 4.9 17.7 11 17.7h25c6.1 0 11-7.9 11-17.7V45.5c0-9.8 4.9-17.7 11-17.7h34c6.1 0 11 7.9 11 17.7v194.9c0 9.8 4.9 17.7 11 17.7h158c6.1 0 11-7.9 11-17.7v-43.5c0-9.8-4.9-17.7-11-17.7h-90c-6.1 0-11-7.9-11-17.7V71.3c0-9.8 4.9-17.7 11-17.7h128c6.1 0 11 7.9 11 17.7v125.6c0 9.8 4.9 17.7 11 17.7h88" fill="none" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2,6"/>
                    <path class="st3" d="M1038.3 204.6h8V226h-8v-21.4z"/>
                    <path d="M1046.3 204.6v2.7h-2.7v-2.7h2.7z"/>
                    <path d="M1043.7 207.2v2.7h-2.7v-2.7h2.7zm2.6 2.7v2.7h-2.7v-2.7h2.7zm-2.7 2.7v2.7h-2.7v-2.7h2.7zm2.7 2.7v2.7h-2.7v-2.7h2.7zm-2.7 2.7v2.7h-2.7V218h2.7zm2.7 2.7v2.7h-2.7v-2.7h2.7z"/>
                    <path d="M1043.6 223.3v2.7h-2.7v-2.7h2.7zm-2.7-18.7v2.7h-2.7v-2.7h2.7zm.1 5.4v2.7h-2.7V210h2.7zm-.1 5.3v2.7h-2.7v-2.7h2.7z"/>
                    <path d="M1041 220.7v2.7h-2.7v-2.7h2.7zM1037.6 203.9v22.8m9.4-22.8v22.8"/>
                    <text transform="rotate(90 2.477 10.523)" class="st5 st6" fill="#f03">
                    START
                    </text>
                    <text transform="rotate(90 426 622.023)" class="st3 st5 st6">
                    FINISH
                    </text>
                </svg>
            </div>



        );
    };
}

export default SvgDisplay;


// WEBPACK FOOTER //
// ./src/common/svgDisplay.js